import PropTypes from 'prop-types';
import { uniqueId } from 'lodash';
import { Style } from '@/components/style';
import './AreaCodeSelector.scss';

const { blackColor, gray3Color } = new Style().getUiConfig();

function AreaCodeSelector({
  areaCode,
  setAreaCode,
  areaCodeList,
  up,
  disabled,
}) {
  return (
    <div className={up ? 'dropup' : ''}>
      <button
        className="btn btn-lg area-code"
        style={{
          border: `1px solid ${gray3Color}`,
          color: `${blackColor}`,
          backgroundColor: `${disabled && '#EFEFEF4C'}`,
        }}
        type="button"
        data-testid="areaCodeDropDownMenu"
        id="areaCodeDropDownMenu"
        data-bs-toggle="dropdown"
        aria-expanded="false"
        disabled={disabled}
      >
        {areaCode?.display}
      </button>
      <ul
        style={{
          border: `1px solid ${gray3Color}`,
        }}
        className="dropdown-menu area-code-list"
        aria-labelledby="areaCodeDropDownMenu"
      >
        {areaCodeList?.map((code) => (
          <li key={uniqueId()}>
            <button
              type="button"
              className="dropdown-item btn-lg text-center"
              style={{ fontSize: '16px', height: '45px' }}
              onClick={() => {
                setAreaCode(code);
              }}
            >
              {code.display}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

AreaCodeSelector.defaultProps = {
  areaCode: null,
  areaCodeList: [],
  up: false,
  disabled: false,
};

AreaCodeSelector.propTypes = {
  areaCode: PropTypes.shape({
    display: PropTypes.string,
  }),
  areaCodeList: PropTypes.arrayOf(PropTypes.shape({})),
  setAreaCode: PropTypes.func.isRequired,
  up: PropTypes.bool,
  disabled: PropTypes.bool,
};

export default AreaCodeSelector;
